<template>
  <div>
    <Toolbar class="p-mb-4">
      <template slot="left">
        <Button
          label="Add Regions"
          icon="pi pi-plus"
          class="p-button-success p-mr-2"
          @click="openNewTypesForm"
        />
      </template>
      <template slot="right">
        <span class="p-input-icon-left">
          <i class="pi pi-search" />
          <InputText v-model="filters['global']" placeholder="Global Search" />
        </span>
      </template>
    </Toolbar>
    <DataTable
      :value="regions"
      :paginator="true"
      class="p-datatable-striped p-datatable-sm p-datatable-gridlines p-datatable-customers"
      :rows="25"
      dataKey="contactId"
      :filters="filters"
      :loading="loading"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      :rowsPerPageOptions="[5, 10, 25]"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Related Accounts"
    >
      <template #header>
        <div class="table-header">Related Region</div>
      </template>

      <template #empty> No Related Job Region found! </template>
      <template #loading> Loading Related Region. Please wait. </template>
      <Column field="id" header="Id" :sortable="true">
        <template #body="slotProps">
          {{ slotProps.data.id ? slotProps.data.id : "" }}
        </template>
      </Column>
      <Column field="regionCode" header="Display Order" :sortable="true">
        <template #body="slotProps">
          {{ slotProps.data.regionCode ? slotProps.data.regionCode : "" }}
        </template>
      </Column>
      <Column field="regionName" header="Region Name" :sortable="true">
        <template #body="slotProps">
          {{ slotProps.data.regionName ? slotProps.data.regionName : "" }}
        </template>
      </Column>
      <Column field="salesExec" header="Sales Exec" :sortable="true">
        <template #body="slotProps">
          {{
            slotProps.data.salesExec
              ? slotProps.data.salesExec.salesExecName
              : ""
          }}
        </template>
      </Column>
      <Column field="mbpBranch" header="Branch" :sortable="true">
        <template #body="slotProps">
          {{
            slotProps.data.mbpBranch ? slotProps.data.mbpBranch.branchName : ""
          }}
        </template>
      </Column>
      <Column field="active" header="Active" :sortable="true">
        <template #body="slotProps">
          <span v-if="slotProps.data.active">YES</span>
          <span v-else>NO</span>
        </template>
      </Column>
      <Column headerStyle="width: 10em;">
        <template #body="slotProps">
          <div :style="{ position: 'relative' }">
            <SplitButton
              label="Edit"
              icon="pi pi-pencil"
              class="p-button-success p-mb-2"
              @click="editRegions(slotProps.data)"
              :model="getButtons(slotProps.data)"
            >
            </SplitButton>
          </div>
        </template>
      </Column>
    </DataTable>
    <Dialog
      :visible.sync="regionForm"
      :style="{ width: '640px', overflowY: 'auto' }"
      header="Region"
      :modal="true"
      class="p-fluid"
    >
      <div class="p-formgrid p-grid">
        <div class="p-field p-col relative">
          <label for="noteHeader">Display Order:</label>
          <InputText
            id="noteHeader"
            v-model.trim="region.regionCode"
            required="true"
            autofocus
          />
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="salutation">Sales Exec</label>
          <Dropdown
            :showClear="true"
            v-model="region.salesExec"
            :options="salesExec"
            optionLabel="salesExecName"
            placeholder="Select Sales Exec"
          />
        </div>
        <div class="p-field p-col">
          <label for="salutation">Branch</label>
          <Dropdown
            :showClear="true"
            v-model="region.mbpBranch"
            :options="branches"
            optionLabel="branchName"
            placeholder="Select Branch"
          />
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="noteDetails">Region Name:</label>
          <InputText
            placeholder=""
            :disabled="false"
            :autoResize="true"
            rows="6"
            v-model="region.regionName"
          />
        </div>
        <div class="p-field p-col">
          <label for="noteDetails">Active:</label>
          <SelectButton
            v-model="region.active"
            :options="options"
            optionLabel="label"
            optionValue="value"
          />
        </div>
      </div>
      <template #footer>
        <Button
          label="Cancel"
          icon="pi pi-times"
          class="p-button-text"
          @click="regionForm = false"
        />
        <Button
          label="Save"
          icon="pi pi-check"
          class="p-button-text"
          @click="save"
        />
      </template>
    </Dialog>
    <Dialog
      header="Confirmation"
      :visible.sync="displayConfirmation"
      :style="{ width: '350px' }"
      :modal="true"
    >
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
        <span>Do you wish to delete the Region?</span>
      </div>
      <template #footer>
        <Button
          label="No"
          icon="pi pi-times"
          @click="closeConfirmation"
          class="p-button-text"
        />
        <Button
          label="Yes"
          icon="pi pi-check"
          @click="deleteRegion"
          class="p-button-text"
          autofocus
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import CustomerService from "@/service/CustomerService";
import PermissionMixin from "../PermissionMixin.vue";
export default {
  mixins: [PermissionMixin],
  customerService: null,
  data: () => ({
    regionForm: false,
    displayConfirmation: false,
    loading: true,
    filters: {},
    regions: null,
    region: {},
    salesExec: [],
    branches: [],
    options: [
      { value: true, label: "yes" },
      { value: false, label: "no" }
    ]
  }),
  methods: {
    getButtons(data) {
      this.checkPermissions();
      let buttons = [];
      if (this.deleteSettings) {
        buttons.push({
          label: "Delete",
          icon: "pi pi-trash",
          command: () => {
            this.openConfirmation(data);
          }
        });
      }
      return buttons;
    },
    openNewTypesForm() {
      this.region = {};
      this.regionForm = true;
    },
    openConfirmation(data) {
      this.region = data;
      this.displayConfirmation = true;
    },
    closeConfirmation() {
      this.displayConfirmation = false;
    },
    editRegions(data) {
      this.region = data;
      this.regionForm = true;
    },
    async deleteRegion() {
      this.closeConfirmation();
      await this.customerService.deleteRegions(this.region.id);
      this.$toast.add({
        severity: "success",
        summary: "Success Message",
        detail: "Region removed",
        life: 5000
      });
      this.getAllRegions();
      this.getAllActiveRegionsByHard();
    },
    save() {
      this.region.salesExec = this.region.salesExec.id;
      this.region.mbpBranch = this.region.mbpBranch.id;
      if (!this.region.id) {
        this.customerService
          .postRegions(this.region)
          .then(res => {
            this.$toast.add({
              severity: "success",
              summary: "Success Message",
              detail: "Region added",
              life: 5000
            });
            this.getAllRegions();
            this.getAllActiveRegionsByHard();
          })
          .catch(err => {
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error while saving region",
              life: 5000
            });
          });
      } else {
        this.customerService
          .putRegions(this.region, this.region.id)
          .then(res => {
            this.$toast.add({
              severity: "success",
              summary: "Success Message",
              detail: "Region updated",
              life: 5000
            });
            this.getAllRegions();
            this.getAllActiveRegionsByHard();
          })
          .catch(err => {
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error while updating region",
              life: 5000
            });
          });
      }
      this.regionForm = false;
    },
    getAllRegions() {
      this.loading = true;

      this.customerService
        .getAllRegionsByHard()
        .then(data => {
          this.regions = data;
          this.loading = false;
        })
        .catch(err => {
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting regions",
          //   life: 5000,
          // })
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content: 'Some data was not loaded from "regions"'
          });
        });
    },
    getAllActiveRegionsByHard() {
      this.customerService
        .getAllActiveRegionsByHard()
        .then(data => {})
        .catch(err => {
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content: 'Some data was not loaded from "activeRegions"'
          });
        });
    }
  },
  created() {
    this.customerService = new CustomerService();
  },
  mounted() {
    this.getAllRegions();

    this.customerService
      .getAllActiveSalesExecs()
      .then(data => {
        this.salesExec = data;
      })
      .catch(err => {
        // this.$toast.add({
        //   severity: "error",
        //   summary: "Error",
        //   detail: "Error while getting salesExec",
        //   life: 5000,
        // })
        this.$store.dispatch("addErrorMessage", {
          severity: "error",
          content: 'Some data was not loaded from "activeSalesExecs"'
        });
      });

    this.customerService
      .getAllActiveMBPBranches()
      .then(data => {
        this.branches = data;
      })
      .catch(err => {
        // this.$toast.add({
        //   severity: "error",
        //   summary: "Error",
        //   detail: "Error while getting branches",
        //   life: 5000,
        // })
        this.$store.dispatch("addErrorMessage", {
          severity: "error",
          content: 'Some data was not loaded from "activeMbpBranches"'
        });
      });
  }
};
</script>
